import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Route, Routes, NavLink, useLocation } from 'react-router-dom';
import RoleDetails from "./AddUserRoleDetails"
import BasicDetails from "./BasicDetails"
import AddDocuments from "./AddDocuments"
import PreviewConfirm from "./PreviewConfirm"
import MasterService from '../../services/MasterService';
import { toast } from 'react-toastify';
import { ECA_AGENT_TAGGING, HRF_BUSINESS_VERTICAL_ID, Role, TENANT, defaultBusiness, defaultVertical, defaultZone } from '../../config/constant';
import Loader from '../common/loader';
import { isServiceError, showServiceErrors } from './ViewUser';
import { getCreateOrUpdateUserPayload } from './helper';

const EditUser = (props) => {
    const [stateList, setStateList] = useState([])
    const [cityList, setCityList] = useState([])
    const [activePageId, setActivePageId] = useState('');
    const [formFillStatusArr, setFormFillStatusList] = useState([]);
    const [user_detail, setUserDetail] = useState({});
    const [loading, setLoading] = useState(false);
    const [ConfigList, setConfigList] = useState([])
    const [user_id, setUserId] = useState(null)
    const [show_detail, setShowDetail] = useState(false)
    const [userLocationDetail, setUserLocationDetail] = useState({})
    const [user_logout, setUserLogout] = useState(0)
    const [serviceErrors, setServiceErrors] = useState([]);
    const urlprefix = '/edit-user';
    const menuList = [
        {
            id: 1,
            index: 1,
            sub_menu: "Role Details",
            sub_menu_url: "role_details"
        },
        {
            id: 2,
            index: 2,
            sub_menu: "Basic Details",
            sub_menu_url: "basic_details"
        },
        {
            id: 3,
            index: 3,
            sub_menu: "Documents",
            sub_menu_url: "documents"
        },
        {
            id: 4,
            index: 4,
            sub_menu: "Preview and Confirm",
            sub_menu_url: "preview_and_confirm"
        }]

    const historyLead = useNavigate();
    const location = useLocation();

    useEffect(() => {
        let search_user_id = location.search && location.search !== "" ? location.search.split("=")[1] : null
        if (search_user_id) {
            setUserId(search_user_id)
            getUserDetail(search_user_id)
        }
        getStateList()
        getCityList()
        // checkValidPath()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getUserDetail = async (user_id) => {
        setLoading(true)
        await MasterService.post('/sfa/user/get-view-detail', { user_id }).then(async function (response) {
            if (response.data.status === 200 && response.data.data && response.data.data.status !== '5') {
                let user_data = response.data.data
                setServiceErrors(user_data?.open_lead_and_reportee_data?.errors || []);
                showServiceErrors(user_data?.open_lead_and_reportee_data?.errors || []);

                let temp_user_detail = { ...user_detail }

                getConfigList(user_data.role_id, user_data?.business_vertical_id, user_data?.business_line || '', user_data?.reporting_response[0]?.manager_role_id || null)
                let role_details = {
                    role: user_data.role_id,
                    reporting_role: user_data.reporting_response.length > 0 && user_data.reporting_response[0].manager_role_id,
                    reporting_manager: user_data.reporting_response.length > 0 && user_data.reporting_response[0].manager_id,
                    zone_id: defaultZone,
                    location_response: user_data.location_response,
                    previous_role_id: user_data.role_id,
                    business_line: user_data.business_line,
                    previous_business_line: user_data.business_line,
                    previous_manager_id: user_data.reporting_response.length > 0 && user_data.reporting_response[0].manager_id,
                    previous_reporting_role: user_data.reporting_response.length > 0 && user_data.reporting_response[0].manager_role_id,
                    business_unit_id: user_data.business_unit_id,
                    business_vertical_id: user_data?.business_vertical_id || defaultVertical,
                    previous_business_unit_id: user_data?.business_unit_id || defaultBusiness
                }
                let basic_details = {
                    created_date: user_data.created_date && isNaN(Date.parse(user_data.created_date)) === false ? new Date(user_data.created_date) : "",
                    approval_date: user_data.approval_date && isNaN(Date.parse(user_data.approval_date)) === false ? new Date(user_data.approval_date) : "",
                    resign_date_1: user_data.resign_date_1 && isNaN(Date.parse(user_data.resign_date_1)) === false ? new Date(user_data.resign_date_1) : "",
                    resign_date_2: user_data.resign_date_2 && isNaN(Date.parse(user_data.resign_date_2)) === false ? new Date(user_data.resign_date_2) : "",
                    rejoin_date_1: user_data.rejoin_date_1 && isNaN(Date.parse(user_data.rejoin_date_1)) === false ? new Date(user_data.rejoin_date_1) : "",
                    rejoin_date_2: user_data.rejoin_date_2 && isNaN(Date.parse(user_data.rejoin_date_2)) === false ? new Date(user_data.rejoin_date_2) : "",
                    warning_date_1: user_data.warning_date_1 && isNaN(Date.parse(user_data.warning_date_1)) === false ? new Date(user_data.warning_date_1) : "",
                    warning_date_2: user_data.warning_date_2 && isNaN(Date.parse(user_data.warning_date_2)) === false ? new Date(user_data.warning_date_2) : "",
                    onboarded_from: user_data.user_source ? user_data.user_source : "",
                    onboarded_by: (user_data.user_source && user_data.user_source === 'admin') ? user_data.created_by_admin_name : user_data.created_by_user_name,
                    hiring_source: user_data.hiring_source ? user_data.hiring_source : "",
                    comments: user_data.comments ? user_data.comments : "",
                    is_tax_booster_enable: user_data.is_tax_booster_enable === "0" ? false : true,
                    profile_image: user_data.profile_image_path,
                    profile_image_original_path: user_data.profile_image_original_path,
                    profile_image_name: user_data.profile_image_name,
                    is_mobile_no_verified: user_data.is_mobile_no_verified ? user_data.is_mobile_no_verified : "0",
                    username: user_data.name,
                    mobile_no: user_data.mobile,
                    email_id: user_data.email,
                    ktp_id: user_data.ktp_id,
                    employment_type: user_data.employe_type,
                    employee_id: user_data.employe_id,
                    joining_date: user_data.doj && isNaN(Date.parse(user_data.doj)) === false ? new Date(user_data.doj) : "",
                    anniversary_date: user_data.anniversary_date && isNaN(Date.parse(user_data.anniversary_date)) === false ? new Date(user_data.anniversary_date) : "",
                    bank_id: user_data.bank_response ? user_data.bank_response.sfa_bank_id : "",
                    bank_branch_name: user_data.bank_response ? user_data.bank_response.branch_name : "",
                    bank_account_number: user_data.bank_response ? user_data.bank_response.account_number : "",
                    confirm_bank_account_number: user_data.bank_response ? user_data.bank_response.account_number : "",
                    beneficiary_name: user_data.bank_response ? user_data.bank_response.beneficiary_name : "",
                    npwp: user_data.bank_response ? user_data.bank_response.NPWP : "",
                    npwp_disabled: ((user_data.id && user_data.id !== '') && (user_data.status === '1' || user_data.status === '0') && (user_data.bank_response && user_data.bank_response.NPWP && (user_data.bank_response.NPWP.replace(/[^0-9]/g, "").length === 15 || user_data.bank_response.NPWP.replace(/[^0-9]/g, "").length === 16))) ? true : false,
                    date_of_birth: user_data.dob && isNaN(Date.parse(user_data.dob)) === false ? new Date(user_data.dob) : "",
                    state_name: user_data.user_state,
                    city: user_data.user_city,
                    user_location: user_data.user_location,
                    current_occupation: user_data.current_occupation_id,//check if this is id
                    company_name: user_data.company_name,
                    company_address: user_data.company_address,
                    designation: user_data.designation_id,
                    tagging_id: user_data.tagging_id,
                    source: user_data.source_id,
                    postal_code: user_data.pincode,
                    rt: user_data.rt,
                    rw: user_data.rw,
                    street_address: user_data.address1,
                    house_number: user_data.house_no,
                    incentive_percentage: user_data.incentive_percentage,
                    address: user_data.address,
                    password: user_data.password,
                    confirm_password: user_data.password,
                    referral_name: user_data.referral_user_id,
                    bm_grading: user_data.bm_grading ? user_data.bm_grading : '',
                    agent_wallet: user_data.agent_wallet ? user_data.agent_wallet : 0,
                    previous_mobile: user_data.mobile,
                    is_subscribe_dif: user_data.is_subscribe_dif && user_data.is_subscribe_dif === 1 ? 1 : 0,
                    whatsapp_mobile_number: user_data.whatsapp_mobile_number ? user_data.whatsapp_mobile_number : 0,
                    alternative_number: user_data.alternative_number ? user_data.alternative_number : 0,
                    approved_by_admin_name: user_data.approved_by_admin_name ? user_data.approved_by_admin_name : "",
                    inactive_by_name: user_data.status === "0" && user_data.inactive_by_name ? user_data.inactive_by_name : "",
                    inactive_date: user_data.status === "0" && user_data.inactive_date && isNaN(Date.parse(user_data.inactive_date)) === false ? new Date(user_data.inactive_date) : "",
                    manager_status: user_data.manager_status ? user_data.manager_status : "",
                    whatsapp_number_verified: user_data.whatsapp_number_verified ? user_data.whatsapp_number_verified : "0",
                    eca_agent: user_data.eca_agent ? user_data.eca_agent : "",
                    eca_validate_tagging_id: user_data.tagging_id,
                    sss_id_number: user_data.sss_id_number,
                    tin_id: user_data.tin_id,
                    aro_so_assigned: user_data.aro_so_assigned,
                    territory_id: (user_data?.territory_id) ? user_data?.territory_id : 0,
                    is_dsa: user_data.is_dsa,
                    birth_place_state_id: user_data.birth_place_state_id,
                    birth_place_city_id: user_data.birth_place_city_id,
                    blood_type_id: user_data.blood_type_id,
                    marital_status_id: user_data.marital_status_id,
                    gender_id: user_data.gender_id,
                    mother_name: user_data.mother_name,
                    father_name: user_data.father_name,
                    show_cbi_info: user_data.show_cbi_info,
                    ...(user_data.cbi_credit_info ?? {}),
                    ...(user_data.hrf_documents ?? {})
                }

                let documents = user_data.document_response
                temp_user_detail["role_details"] = role_details
                temp_user_detail["basic_details"] = basic_details
                temp_user_detail["user_id"] = user_data.id
                temp_user_detail["user_id_hash"] = user_data.user_id_hash;
                temp_user_detail["status"] = user_data.status
                temp_user_detail["documents"] = documents
                temp_user_detail["open_lead_and_reportee_data"] = user_data.open_lead_and_reportee_data
                temp_user_detail["is_dsa_previous"] = user_data?.is_dsa || 0
                setUserDetail(temp_user_detail)
                getUserLocationDetail(user_data.user_id_hash, temp_user_detail, user_data)


            } else {
                if (response.data.status === 400 && response.data.message) {
                    toast.error(response.data.message)
                } else {
                    toast.error("Invalid request")
                }
                historyLead("/user-management-detail")
            }
        })
    }

    const getUserLocationDetail = async (user_id, temp_user_detail, user_data) => {
        await MasterService.post('/sfa/user/get-user_location', { user_id }).then(function (response) {
            if (response.data.status === 200) {
                let data = response.data.data
                let state_data = data.location_response.map(({ state_id }) => state_id)
                state_data = state_data.filter((item, i, ar) => ar.indexOf(item) === i);
                let city_data = data.location_response.map(({ city_id }) => city_id)
                city_data = city_data.filter((item, i, ar) => ar.indexOf(item) === i);
                temp_user_detail.role_details.state = state_data
                temp_user_detail.role_details.city = city_data

                let temp_user_loc = { ...userLocationDetail }
                temp_user_loc.state_data = state_data
                temp_user_loc.city_data = city_data
                setUserLocationDetail(temp_user_loc)
                setUserDetail(temp_user_detail)
                getActivePageId(user_data)
                setShowDetail(true)
                setLoading(false)
            } else {
                toast.error(response.data.message)
                setLoading(false)
            }
        })
    }

    // const checkValidPath = () => {//removed warning
    //     if (Object.keys(user_detail).length === 0) {
    //         handleReset()
    //         historyLead('/edit-user/role_details');
    //     }
    // }

    const getActivePageId = async (user_data) => {
        if (user_data.role_id) {
            let tempformFillStatusArr = formFillStatusArr
            setActivePageId(menuList[0].id)
            if (!tempformFillStatusArr.includes(menuList[0].id)) {
                tempformFillStatusArr.push(menuList[0].id)
            }
            setFormFillStatusList(tempformFillStatusArr)
        }
        if (user_data.email) {
            let tempformFillStatusArr = formFillStatusArr
            setActivePageId(menuList[1].id)
            if (!tempformFillStatusArr.includes(menuList[1].id)) {
                tempformFillStatusArr.push(menuList[1].id)
            }
            setFormFillStatusList(tempformFillStatusArr)
        }
        if (user_data.document_response && user_data.document_response.length > 0) {
            let tempformFillStatusArr = formFillStatusArr
            setActivePageId(menuList[2].id)
            if (!tempformFillStatusArr.includes(menuList[2].id)) {
                tempformFillStatusArr.push(menuList[2].id)
            }
            setFormFillStatusList(tempformFillStatusArr)
        }
    }

    const getConfigList = async (role_id, vertical_id, selected_business_line = '', reporting_role = null) => {
        MasterService.post('/sfa/user/get-config', { role_id: role_id, send_bm_grading: true, vertical_id, selected_business_line })
            .then(function (response) {
                if (response.data.status === 200) {
                    let responseData = response.data.data;
                    if (role_id === Role['Agent']) {
                        if (reporting_role && reporting_role === Role['ARO']) {
                            responseData.tagging_roles = responseData?.tagging_roles?.filter(item => ![...ECA_AGENT_TAGGING, 'dsoo'].includes(item.value)) || [];
                        } else if (reporting_role && reporting_role !== Role['BM']) {
                            responseData.tagging_roles = responseData?.tagging_roles?.filter(item => !ECA_AGENT_TAGGING.includes(item.value)) || [];
                        }
                    }
                    setConfigList(responseData)
                } else {
                    toast.error(response.data.message);
                }
            })
            .catch(function (response) {
            });
    }

    const getStateList = async () => {
        MasterService.post('/sfa/user/state_list', {})
            .then(function (response) {
                if (response.data.status === 200) {
                    var state_list = response.data.data.map(elm => ({ id: elm.id, label: elm.state_name, value: elm.id }));
                    setStateList(state_list);
                } else {
                    toast.error(response.data.message);
                }
            })
            .catch(function (response) {
            });
    }

    const getCityList = async (state_ids) => {
        MasterService.post('/sfa/user/city_list', { state_ids })
            .then(function (response) {
                if (response.data.status === 200) {
                    var city_list = response.data.data.map(elm => ({ id: elm.id, label: elm.city_name, value: elm.id, state_id: elm.state_id }));
                    setCityList(city_list);
                } else {
                    toast.error(response.data.message);
                }
            })
            .catch(function (response) {
            });
    }

    const handleReset = () => {
        setActivePageId('')
        setFormFillStatusList([])
    }

    const handleSave = async (element, name, save_detail) => {
        let temp_user_detail = { ...user_detail }
        temp_user_detail[name] = element
        setUserDetail(temp_user_detail)
        if (save_detail) {
            handleCreateUser(temp_user_detail[name])
        }

        let index = menuList.findIndex(x => x.sub_menu_url === name);
        let next_element = menuList[index + 1]
        let current_element = menuList[index]
        setActivePageId(next_element.id)
        let tempformFillStatusArr = formFillStatusArr
        if (!tempformFillStatusArr.includes(current_element.id)) {
            tempformFillStatusArr.push(current_element.id)
        }
        setFormFillStatusList(tempformFillStatusArr)
    }

    const uploadProfileImages = async (profile_image_file,business_vertical_id) => {
        let profile_data = {}
        var formData = new FormData();
        formData.append("upload_type", "sfa_docs");
        formData.append("visit_id", `user/${user_detail.user_id}`);
        if(business_vertical_id === HRF_BUSINESS_VERTICAL_ID) {
            formData.append("upload_doc_type", "home-loan");
        }
        formData.append("images", profile_image_file);
        await MasterService.uploadFilesToS3(formData, {
            "Content-Type": "multipart/form-data",
        }).then((result) => {
            if (result.data.status === 200) {
                profile_data.profile_image_name = result.data.data[0].file_name;
                profile_data.profile_image_path = result.data.data[0].file_url;
            }
            toast.success("Profile Image uploaded")
        })
        return profile_data
    }

    const uploadImages = async (added_documents, business_vertical_id) => {
        let document_info = []
        for (let index = 0; index < added_documents.length; index++) {
            let element = added_documents[index]
            let doc_object = {}
            if (element.doc_url.includes("blob")) {
                var formData = new FormData();
                formData.append("upload_type", "sfa_docs");
                formData.append("visit_id", `user/${user_detail.user_id}`);
                if(business_vertical_id === HRF_BUSINESS_VERTICAL_ID) {
                    formData.append("upload_doc_type", "home-loan");
                }
                formData.append("images", element.doc_file);
                await MasterService.uploadFilesToS3(formData, {
                    "Content-Type": "multipart/form-data",
                }).then((result) => {
                    if (result.data.status === 200) {
                        let config_doc = ConfigList.document.filter(e => e.id === element.document_id)
                        doc_object.document_id = element.document_id
                        doc_object.doc_url = result.data.data[0].file_url;
                        doc_object.is_doc_verified = element.is_doc_verified ? element.is_doc_verified : 0
                        toast.success(config_doc[0].doc_title + " uploaded")
                    }
                    document_info.push(doc_object)
                })
            } else {
                doc_object.document_id = element.document_id
                doc_object.doc_url = element.doc_original_url ? element.doc_original_url : element.doc_url
                doc_object.is_doc_verified = element.is_doc_verified ? element.is_doc_verified : 0
                document_info.push(doc_object)
            }
        }
        return document_info
    }

    const handleCreateUser = async (user_basic_details) => {
        if (isServiceError(serviceErrors)) {
            showServiceErrors(serviceErrors)
            return
        }
        setLoading(true)
        let profile_data = {}
        let basic_details = {}
        if (user_basic_details && Object.keys(user_basic_details).length) {
            basic_details = user_basic_details
        } else {
            basic_details = user_detail.basic_details ? user_detail.basic_details : {}
        }
        let { role_details, documents } = user_detail
        let business_vertical_id=role_details.business_vertical_id ?? defaultVertical;
        if (basic_details.profile_image_file) {
            profile_data = await uploadProfileImages(basic_details.profile_image_file, business_vertical_id)

        } else {
            profile_data = {
                profile_image_name: basic_details.profile_image_name ? basic_details.profile_image_name : "",
                profile_image_path: basic_details.profile_image_original_path ? basic_details.profile_image_original_path : basic_details.profile_image
            }
        }
        let modified_documents = await uploadImages(documents, business_vertical_id)
        let city_data = cityList.filter((e) => role_details.city.includes(e.id))
        let stateListTemp = city_data.map(({ state_id }) => state_id)
        stateListTemp = stateListTemp.filter((item, i, ar) => ar.indexOf(item) === i);
        let state_data = stateList.filter((e) => stateListTemp.includes(e.id))
        let payload = await getCreateOrUpdateUserPayload({ TENANT, user_detail, basic_details, role_details, profile_data, modified_documents, state_data, city_data, user_logout });

        MasterService.post('/sfa/user/create_user', payload).then(function (response) {
            setLoading(false)
            if (response.data.status === 200) {

                if (response.data.message === "FAILED") {
                    if (response.data.data && Object.keys(response.data.data).length > 0) {
                        for (const key in response.data.data) {
                            if (Object.hasOwnProperty.call(response.data.data, key)) {
                                const element = response.data.data[key];
                                toast.error(element.error_message);
                            }
                        }

                    }
                } else {
                    let user_id = response.data.data.user_id_hash
                    toast.success("User Updated Successfully");
                    historyLead('/view-user/' + user_id);
                }

            } else {
                if (response.data.error && response.data.error.length > 0) {
                    response.data.error.forEach(element => {
                        toast.error(element);
                    });
                }
            }
        }).catch(function (error) {
            toast.error(error?.message);
            setLoading(false)
        });
    }

    const updateEcaAgent = async (params) => {
        let temp_detail = { ...user_detail }
        let temp_basic_details = temp_detail.basic_details ? temp_detail.basic_details : {}
        //temp_basic_details["tagging_id"] = ""
        temp_detail.basic_details = temp_basic_details
        setUserDetail(temp_detail)
    }


    const updateBasicDetail = () => {
        let temp_detail = { ...user_detail }
        let temp_basic_details = temp_detail.basic_details ? temp_detail.basic_details : {}
        temp_basic_details["tagging_id"] = ""
        temp_basic_details["current_occupation"] = ""
        temp_basic_details["designation"] = ""
        temp_detail.basic_details = temp_basic_details
        setUserDetail(temp_detail)
    }

    // const resetTagging = () => {
    //     let temp_detail = { ...user_detail }
    //     let temp_basic_details = temp_detail.basic_details ? temp_detail.basic_details : {}
    //     temp_basic_details["tagging_id"] = ""
    //     temp_detail.basic_details = temp_basic_details
    //     setUserDetail(temp_detail)
    // }

    const renderSwitch = (param, index) => {
        switch (param.sub_menu) {
            case 'Role Details':
                // return <Route exact path={urlprefix + '/role_details'}>
                //     {show_detail &&
                //         <RoleDetails
                //             stateList={stateList}
                //             cityList={cityList}
                //             user_detail={user_detail}
                //             getConfigList={getConfigList}
                //             updateBasicDetail={updateBasicDetail}
                //             handleSave={handleSave}
                //             setUserLogout={setUserLogout}
                //             location_state={props.location.state}
                //         />
                //     }
                // </Route>;
                return (
                    <>
                        {show_detail &&
                            <Routes>
                                <Route
                                    path='/role_details'
                                    element={
                                        <RoleDetails
                                            stateList={stateList}
                                            cityList={cityList}
                                            user_detail={user_detail}
                                            getConfigList={getConfigList}
                                            updateBasicDetail={updateBasicDetail}
                                            handleSave={handleSave}
                                            setUserLogout={setUserLogout}
                                            location_state={props?.location?.state}
                                            ConfigList={ConfigList}
                                            setConfigList={setConfigList}
                                            updateEcaAgent={updateEcaAgent}
                                        // resetTagging={resetTagging}
                                        />
                                    }
                                />
                            </Routes>
                        }
                    </>
                );
            case 'Basic Details':
                // return <Route exact path={urlprefix + '/basic_details'}>
                //     {Object.keys(ConfigList).length > 0 && stateList.length > 0 && cityList.length > 0 && Object.keys(user_detail).length > 0 &&
                //         <BasicDetails
                //             stateList={stateList}
                //             cityList={cityList}
                //             ConfigList={ConfigList}
                //             user_detail={user_detail}
                //             handleSave={handleSave}
                //             handleReset={handleReset}
                //             location_state={props.location.state}
                //         />
                //     }
                // </Route>;
                return (
                    <>
                        {Object.keys(ConfigList).length > 0 && stateList.length > 0 && cityList.length > 0 &&
                            <Routes>
                                <Route
                                    path='/basic_details'
                                    element={
                                        <BasicDetails
                                            stateList={stateList}
                                            cityList={cityList}
                                            ConfigList={ConfigList}
                                            user_detail={user_detail}
                                            handleSave={handleSave}
                                            handleReset={handleReset}
                                            location_state={props?.location?.state}
                                        />
                                    }
                                />
                            </Routes>
                        }
                    </>
                );
            case 'Documents':
                // return <Route exact path={urlprefix + '/documents'}>
                //     {Object.keys(ConfigList).length > 0 && stateList.length > 0 && cityList.length > 0 &&
                //         <AddDocuments
                //             ConfigList={ConfigList}
                //             user_detail={user_detail}
                //             handleSave={handleSave}
                //             handleReset={handleReset}
                //             location_state={props.location.state}
                //         />
                //     }
                // </Route>;
                return (
                    <>
                        {Object.keys(ConfigList).length > 0 && stateList.length > 0 && cityList.length > 0 &&
                            <Routes>
                                <Route
                                    path='/documents'
                                    element={
                                        <AddDocuments
                                            ConfigList={ConfigList}
                                            user_detail={user_detail}
                                            handleSave={handleSave}
                                            handleReset={handleReset}
                                            location_state={props?.location?.state}
                                        />
                                    }
                                />
                            </Routes>
                        }
                    </>
                );
            case 'Preview and Confirm':
                // return <Route exact path={urlprefix + '/preview_and_confirm'}>
                //     {Object.keys(ConfigList).length > 0 && stateList.length > 0 && cityList.length > 0 &&
                //         <PreviewConfirm
                //             stateList={stateList}
                //             cityList={cityList}
                //             handleCreateUser={handleCreateUser}
                //             user_detail={user_detail}
                //             ConfigList={ConfigList}
                //             handleReset={handleReset}
                //         />
                //     }
                // </Route>;
                return (
                    <>
                        {Object.keys(ConfigList).length > 0 && stateList.length > 0 && cityList.length > 0 &&
                            <Routes>
                                <Route
                                    path='/preview_and_confirm'
                                    element={
                                        <PreviewConfirm
                                            stateList={stateList}
                                            cityList={cityList}
                                            handleCreateUser={handleCreateUser}
                                            user_detail={user_detail}
                                            ConfigList={ConfigList}
                                            handleReset={handleReset}
                                        />
                                    }
                                />
                            </Routes>
                        }
                    </>
                );
            default:

        }
    }

    const handleMenuClick = (sub_menu, index, e) => {
        const linkDisabled = (activePageId > sub_menu.id) ? false : true;
        if (linkDisabled)
            e.preventDefault()

        else {
            setActivePageId(sub_menu.id)
            let tempformFillStatusArr = formFillStatusArr
            if (!tempformFillStatusArr.includes(sub_menu.id)) {
                tempformFillStatusArr.push(sub_menu.id)
                setFormFillStatusList(tempformFillStatusArr)
            }
        }
    }

    return (
        < React.Fragment >
            <div className='add-user-outer'>
                {loading ? <Loader /> : null}
                <div className="add-user-form-sec">
                    <div className="menu-tab-left-panel">
                        <div className='add-user-detail-filed'><h2>Edit User</h2></div>
                        <div className="add-user-left-panel nav">
                            <ul>
                                {
                                    menuList.length !== 0 && menuList.map((menu, index) => (
                                        <li key={index}>
                                            <NavLink to={urlprefix + '/' + menu.sub_menu_url + "?=" + user_id} className={(formFillStatusArr && formFillStatusArr.includes(menu.id)) ? 'completed' : (activePageId === menu.id) ? 'active' : ''} aria-current="page" exact onClick={handleMenuClick.bind(this, menu, index)} >
                                                <span className="img-type"></span>
                                                {menu.sub_menu}
                                            </NavLink>
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="route-files">
                        {
                            menuList.length !== 0 && menuList.map((menu, k) => (
                                <div key={k}>
                                    {renderSwitch(menu)}
                                </div>
                            ))
                        }
                    </div>
                </div>

            </div>

        </React.Fragment >
    )
}
//}
export default EditUser;
